// extracted by mini-css-extract-plugin
export var productImage = "_ya-0";